__turbopack_context__.v({
  "btn": "icon-button-module__5gh_MG__btn",
});
